/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TellerListResponseDto { 
    id?: number;
    name?: string | null;
    userName?: string | null;
    emailAddress?: string | null;
    branchName?: string | null;
    lastLogin?: string | null;
    vaultBalance?: number;
    accountId?: number | null;
    accountNumber?: string | null;
}

